export const ADD_VEHICLE_ATTACHMENT = "ADD_VEHICLE_ATTACHMENT";
export const ADD_VEHICLE_ATTACHMENT_SUCCESS = "ADD_VEHICLE_ATTACHMENT_SUCCESS";
export const ADD_VEHICLE_ATTACHMENT_FAIL = "ADD_VEHICLE_ATTACHMENT_FAIL";

export const DELETE_ATTACHMENT = "DELETE_ATTACHMENT";
export const DELETE_ATTACHMENT_SUCCESS = "DELETE_ATTACHMENT_SUCCESS";
export const DELETE_ATTACHMENT_FAIL = "DELETE_ATTACHMENT_FAIL";

export const DELETE_VEHICLE = "DELETE_VEHICLE";
export const DELETE_VEHICLE_SUCCESS = "DELETE_VEHICLE_SUCCESS";
export const DELETE_VEHICLE_FAIL = "DELETE_VEHICLE_FAIL";

export const UPDATE_VEHICLE = "UPDATE_VEHICLE";
export const UPDATE_VEHICLE_SUCCESS = "UPDATE_VEHICLE_SUCCESS";
export const UPDATE_VEHICLE_FAIL = "UPDATE_VEHICLE_FAIL";

export const VEHICLE_DETAILS = "VEHICLE_DETAILS";
export const VEHICLE_DETAILS_SUCCESS = "VEHICLE_DETAILS_SUCCESS";
export const VEHICLE_DETAILS_FAIL = "VEHICLE_DETAILS_FAIL";

export const ADD_VEHICLE = "ADD_VEHICLE";
export const ADD_VEHICLE_SUCCESS = "ADD_VEHICLE_SUCCESS";
export const ADD_VEHICLE_FAIL = "ADD_VEHICLE_FAIL";

export const VEHICLES_LIST = "VEHICLES_LIST";
export const VEHICLES_LIST_SUCCESS = "VEHICLES_LIST_SUCCESS";
export const VEHICLES_LIST_FAIL = "VEHICLES_LIST_FAIL";

export const VEHICLE_HISTORY = "VEHICLE_HISTORY";
export const VEHICLE_HISTORY_SUCCESS = "VEHICLE_HISTORY_SUCCESS";
export const VEHICLE_HISTORY_FAIL = "VEHICLE_HISTORY_FAIL";

export const GET_VEHICLE_LOGS = "GET_VEHICLE_LOGS";
export const GET_VEHICLE_LOGS_SUCCESS = "GET_VEHICLE_LOGS_SUCCESS";
export const GET_VEHICLE_LOGS_FAIL = "GET_VEHICLE_LOGS_FAIL";
